import Button from '@nebula/button';
import styled from 'styled-components';

export const BodyContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 24px;
  text-align: center;
  max-width: 390px;
`;

export const TryAgainButton = styled(Button)`
  background-color: ${({ theme }) => theme.color.decorative.magenta[70]} !important;
  border: none;
  font-size: 14px;
  > span {
    line-height: 20px;
  }
`;
